import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { InventoryItemComponentFormGroup } from './inventory-item-component-form-group.interface';

@Injectable()
export class InventoryItemComponentFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    componentInventoryItemId: 'componentInventoryItemId',
    quantity: 'quantity',
    sortOrder: 'sortOrder',
  } as const;

  public readonly form: FormGroup<InventoryItemComponentFormGroup>;

  constructor() {
    this.form = InventoryItemComponentFormModel.buildFormGroup(this.formBuilder);
  }

  public buildFormGroup(): FormGroup<InventoryItemComponentFormGroup> {
    return InventoryItemComponentFormModel.buildFormGroup(this.formBuilder);
  }

  public static buildFormGroup(formBuilder: FormBuilder): FormGroup<InventoryItemComponentFormGroup> {
    return formBuilder.group<InventoryItemComponentFormGroup>({
      componentInventoryItemId: new FormControl<string | null>(null, {
        validators: [Validators.required],
      }),
      quantity: new FormControl(1, {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0.0001)],
      }),
      sortOrder: new FormControl<number | null>(null),
    });
  }
}
